import { Icon, Notification, Typography } from '@smartgift/frontend-toolkit';
import { useMutation } from '@tanstack/react-query';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { organizationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

const CustomContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

export const useSendToApproval = ({ options = {} } = {}) => {
  const { showSuccess, showNotification } = useNotification();

  const { onSuccess } = options;
  const { t } = useTranslation();

  return useMutation(body => organizationServices.sendToApproval(body), {
    ...options,
    onSuccess: () => {
      showSuccess({
        message: t('successfullySentApproveToFacilityMessage'),
        type: 'toast'
      });
      if (onSuccess) onSuccess();
    },
    onError: () => {
      showNotification({
        header: t('eGiftCardApprovalPending'),
        customContent: () => (
          <CustomContentWrapper>
            <Notification
              style={{ margin: '8px 0' }}
              status="info"
              message={
                <Trans i18nKey="eGiftCardWasCouldNotAddedRecognition" components={{ b: <b /> }} />
              }
            />
            <Icon name="clock" size="xxl" />
            <Typography>
              <Trans i18nKey="yourApprovalRequestIsReviewed" components={{ b: <b /> }} />
            </Typography>
          </CustomContentWrapper>
        )
      });
    }
  });
};
